<script>
export default {
  props: {
    download: String,
    href: String,
    icon: String,
    target: String,
    processing: Boolean,
    disabled: Boolean,
    inactive: Boolean,
    hidden: Boolean,
    title: String,
    type: String,
    small: String,
  },
  computed: {
    classes() {
      let classes = {};

      classes['vs-icon-button--disabled'] = this.disabled;
      classes['vs-icon-button--processing'] = this.processing;
      classes['vs-icon-button--hidden'] = this.hidden;
      classes['vs-icon-button--small'] = this.small;

      if (this.processing) classes['mdi-loading'] = true;
      else classes[`mdi-${this.icon}`] = true;

      if (this.type === 'delete') classes['vs-icon-button--delete'] = true;
      else if (this.type === 'info') classes['vs-icon-button--info'] = true;
      else if (this.type === 'toggle' && this.inactive) classes['vs-icon-button--toggle-inactive'] = true;

      return classes;
    },
  },
  methods: {
    handleClick() {
      if (!this.processing && !this.disabled) this.$emit('click');
    },
  },
};
</script>

<template lang='pug'>
a.mdi.vs-icon-button(
  v-if='download',
  download,
  :href='download',
  :title='title',
  :target='target',
  :class='classes',
)
a.mdi.vs-icon-button(
  v-else-if='href',
  :href='href',
  :title='title',
  :target='target',
  :class='classes',
)
.mdi.vs-icon-button(
  v-else,
  :title='title',
  :target='target',
  :class='classes',
  @click='handleClick',
)
</template>